import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const MailIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"mail"} ref={ref}/>
});

MailIcon.displayName = "MailIcon";
